import { ConditionParams } from "@multiweb/clients/dataReader";
import { ChartType } from "../../../../UI.Controls/ChartElement";
import { IChartColumnDefinition } from "../../../../UI.Controls/DataGridSubcontrols/Columns/ColumnFactory";
import { IFrameProfileInfo } from "../../IFrameColumnInfo";
/**
 * Veškerá data profilu pro formulář
 */
export interface IFormProfileDataContainer {
    /**
     * Data jednotlivých framů, kde klíčem je název framu
     * @param frameName Název framu
     */
    [frameName: string]: IFrameProfileInfo | IFormProfileInfo;
    /**
     * Data profilu přímo pro formulář
     */
    formProfileData?: IFormProfileInfo; // tato property spoléhá na to, že nikdo nepojmenuje svůj frame jako "formProfileData" - bohužel jsme tuto strukturu udělali málo obecnou a kvůli zpětné kompatibilitě to už nejde změnit
}

/**
 * Data profilu přímo pro formulář
 */
export interface IFormProfileInfo {
    /**
     * Nastavení jednotlivých SplitPanelů
     */
    splitPanels: {
        [splitPanelId: string]: ISplitaPanelProfileInfo;
    };

    /**
     * Pokud je true, tak zabrání načtení dat při otevření formuláře
     */
    queryMode?: boolean | null;

    /**
     * Příznak, zda se mají ukládat aktivní filtry framů
     */
    storeFilters?: boolean | null;
}

/**
 * Data profilu pro SplitPanel
 */
export interface ISplitaPanelProfileInfo {
    /**
     * Procentuální pozice splitteru
     */
    position: number;
}

export interface IChartProfileInfo extends IFrameProfileInfo {
    chartName: string;
    chartType: ChartType;
    condition: string;
    conditionParams?: ConditionParams;
    dataSets: IChartColumnDefinition[];
    displayFormat?: string;
    frameName: string;
    masterFrameName: string;
    objectName: string;
    showAxisValues: boolean;
    showLegend: boolean;
    horizontal: boolean;
    xAxisAttr: string;
}

export class IChartProfileInfo implements IFrameProfileInfo {
    private static _properties: (keyof IChartProfileInfo)[] = ["condition", "chartName", "chartType",
        "dataSets", "frameName", "masterFrameName", "objectName", "showLegend", "showAxisValues", "xAxisAttr"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value)) && instance instanceof IFrameProfileInfo;
    }
}
